//
//
//
//
//
//
//
//
//

import {mapState} from 'vuex'
import CartMb from "./CartMb.vue";
import CartPc from "./CartPc.vue";

export default {
  name: 'cart',
  data(){
    return {

    }

  },
  components: {
    CartMb,
    CartPc,
  },
  computed:{
    ...mapState([
      'global'
    ]),
  }
}



// WEBPACK FOOTER //
// ./src/pages/cart/Cart.vue